const FE_ONLY_NON_DEFERRABLE = [
  'gore_prior_cancellations_within_the_last_6_years_property',
];

const isDeferralAllowed = (
  validationId: string,
  validations: Validation[],
  isRestrictionEnabled: boolean,
): boolean => {
  if (!isRestrictionEnabled) return true;
  if (FE_ONLY_NON_DEFERRABLE.includes(validationId)) return false;

  const validation = validations.find((v) => v.validation_id === validationId);

  return validation?.validation_outcome_data?.is_deferrable !== false;
};

export default isDeferralAllowed;
